
import { ActivityDetails } from "@components";

export const ActivityDetailPage=()=>{
    return(
        <>
          <ActivityDetails/>
        </>
   
    )
}

